// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1GK04","head":"Table_head__3DC3V","col":"Table_col__1m12g"};